import React, { FC } from "react";
import styles from "./highlight-banner-skin-1.module.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { TypeOptionConfig, concatEllipsis } from "@commons-monorepo/index";
// import { UiButton } from "@ui-monorepo/index";
import { UiButton } from "@ui-monorepo/index";
import parse from "html-react-parser";
import { useBannerNavigation } from "../../hooks";
import { HighlightBannerProps } from "../../types";
import WidgetContainer from "../../../widget-container";

const HighlightBannerSkin1: FC<HighlightBannerProps> = ({
  data,
  config,
  log,
  theme
}) => {
  const highLightBackground = config?.highlight_background;
  const { t } = useTranslation();
  const navigateTo = useBannerNavigation(config);
  const reverse = config?.banner_layout === TypeOptionConfig.layout2;
  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500
  };

  const navigate = () => {
    navigateTo(
      config?.banner_custom_information?.button_target || data?.buttonTarget
    );
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLightBackground}>

      <article
        className={`${styles.highlightBannerContainer} ${
        reverse ? styles.highlightBannerReverse : ""
        }`}>

        <div className={`${styles.headerBanner}`}>
          <h2 className={`${styles.title}`}>{data?.title}</h2>
        </div>
        <div className={`${styles.images}`}>
          <div
            className={`${styles.imagesGrid} ${
            data?.images && data.images.length > 1 ?
            styles.imagesGridMultiple :
            ""
            }`}>

            {data?.images?.map((image, index) => {
              return (
                <img
                  loading={"lazy"}
                  key={`image-grid-${index}`}
                  className={`${styles.image}`}
                  src={(image as string)}
                  alt={"index"}
                  onClick={() => {
                    if (config?.banner_custom_information?.show_cta) {
                      navigate();
                    }
                  }} />);


            })}
          </div>
          <div className={`${styles.imagesSlider}`}>
            <Slider {...settings}>
              {data?.images?.map((image, index) => {
                return (
                  <img
                    key={`image-slider-${index}`}
                    className={`${styles.image}`}
                    onClick={() => {
                      if (config?.banner_custom_information?.show_cta) {
                        navigate();
                      }
                    }}
                    src={(image as string)}
                    alt={`${index}`} />);


              })}
            </Slider>
          </div>
        </div>
        <div className={`${styles.info}`}>
          <div className={styles.description}>
            {parse(concatEllipsis(data?.description ?? "", 300))}
          </div>
          {config?.banner_custom_information?.show_cta &&
          <UiButton
            isFilled
            className={styles.button}
            onClick={() => navigate()}
            theme={theme}>

              {config?.banner_custom_information?.cta_text ||
            t("highLightBanner.more")}
            </UiButton>}

        </div>
      </article>
    </WidgetContainer>);

};

export default HighlightBannerSkin1;